import { Partner } from '../../model/partner/partner.model';

export const PARTNERS: Partner[] = [
  {
    name: 'github',
    src: 'https://raw.githubusercontent.com/open-template-hub/open-template-hub.github.io/master/assets/third-parties/logo-wide/github.png',
    website: 'https://github.com',
    badge: 'https://raw.githubusercontent.com/open-template-hub/open-template-hub.github.io/master/assets/third-parties/badge/github.png',
  },
  {
    name: 'aws',
    src: 'https://raw.githubusercontent.com/open-template-hub/open-template-hub.github.io/master/assets/third-parties/logo-wide/aws.png',
    website: 'https://aws.amazon.com'
  },
  {
    name: 'heroku',
    src: 'https://raw.githubusercontent.com/open-template-hub/open-template-hub.github.io/master/assets/third-parties/logo-wide/heroku.png',
    website: 'https://heroku.com',
    badge: 'https://raw.githubusercontent.com/open-template-hub/open-template-hub.github.io/master/assets/third-parties/badge/heroku.png'
  },
  {
    name: 'google',
    src: 'https://raw.githubusercontent.com/open-template-hub/open-template-hub.github.io/master/assets/third-parties/logo-wide/google.png',
    website: 'https://google.com'
  },
  {
    name: 'stripe',
    src: 'https://raw.githubusercontent.com/open-template-hub/open-template-hub.github.io/master/assets/third-parties/logo-wide/stripe.png',
    website: 'https://stripe.com'
  },
  {
    name: 'netlify',
    src: 'https://raw.githubusercontent.com/open-template-hub/open-template-hub.github.io/master/assets/third-parties/logo-wide/netlify.png',
    website: 'https://www.netlify.com'
  },
  {
    name: 'oracle',
    src: 'https://raw.githubusercontent.com/open-template-hub/open-template-hub.github.io/master/assets/third-parties/logo-wide/oracle.png',
    website: 'https://oracle.com'
  },
];
